import React from 'react';
import format from 'date-fns/format';

import { StatusIcon } from '@components/icons';
import { Color } from '../constants';
import InfoItem from './InfoItem';

function Status({ t, isActivate, online, lastOnline }) {
  return isActivate ? (
    <InfoItem
      icon={<StatusIcon />}
      text={
        !online
          ? `${t('offline')} ${t('since')} ${format(
              new Date(lastOnline),
              'dd.MM.yy, HH:mm'
            )}`
          : t('online')
      }
      color={lastOnline ? 'danger' : 'success'}
    />
  ) : (
    <InfoItem
      icon={<StatusIcon />}
      text={t('activate-device')}
      color={Color.WARNING}
    />
  );
}

export default Status;
